import { SITE_URL, SITE_NAME } from "./site";

export interface SeoHeadData {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogUrl?: string;
  ogImage?: string;
  twitterCard?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterImage?: string;
}

function ensureMeta(attr: "name" | "property", key: string): HTMLMetaElement {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  return el;
}

function ensureLink(rel: string): HTMLLinkElement {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  return el;
}

function setMeta(attr: "name" | "property", key: string, content: string | undefined) {
  if (!content) return;
  const el = ensureMeta(attr, key);
  el.setAttribute("content", content);
}

export function applySeoHead(data: SeoHeadData) {
  document.title = data.title;

  setMeta("name", "description", data.description);
  setMeta("name", "keywords", data.keywords);

  if (data.canonical) {
    const canonical = ensureLink("canonical");
    canonical.setAttribute("href", data.canonical);
  }

  setMeta("property", "og:title", data.ogTitle || data.title);
  setMeta("property", "og:description", data.ogDescription || data.description);
  setMeta("property", "og:url", data.ogUrl || data.canonical || SITE_URL);
  setMeta("property", "og:site_name", SITE_NAME);
  setMeta("property", "og:type", "website");
  setMeta("property", "og:image", data.ogImage);

  setMeta("name", "twitter:card", data.twitterCard || "summary_large_image");
  setMeta("name", "twitter:title", data.twitterTitle || data.ogTitle || data.title);
  setMeta(
    "name",
    "twitter:description",
    data.twitterDescription || data.ogDescription || data.description
  );
  setMeta("name", "twitter:image", data.twitterImage || data.ogImage);
}